import React, { useEffect, useState } from "react";
import { Button, Modal, Spinner } from "react-bootstrap-v5";
import { MdEdit, MdOutlineDeleteForever} from "react-icons/md";
import { SubAdminService } from "../../Services/SubAdminService";
import { toast } from "react-toastify";
import { useHistory } from "react-router-dom";
import helperFunction from "../../Function/helperFunction";

export const SubAdminList = () => {
  const [adminList,setAdminList] = useState([])
  const [deleteModal,setDeleteModal] = useState({modal:false,id:null})
  const [loader,setLoader] = useState(false)
  const history = useHistory()

  const getDetail = async () => {
    setLoader(true);
    await SubAdminService.getSubAdminList().then((res) => {
      setLoader(false);
      if (res.status) {
        setAdminList(res.data);
      }
    });
  };

  const handleDelete = async () => {
    const obj = {id: deleteModal.id};
    await SubAdminService.deleteSubAdmin(obj).then((res) => {
      setLoader(true);
      if (res.status) {
        setLoader(false);
        getDetail();
        toast.success(res.message);
        setDeleteModal({modal:false,id:null})
      } else {
        setLoader(false);
        toast.error(res.message);
      }
    });
  };

  useEffect(() => {
    getDetail();
  }, []);

  return (
    <div style={{ width: "75%" }}>
      <div className="card">
        <div className="card-body">
          <div className="text-end mb-3">
            <Button
              type="button"
              className="btn btn-primary"
              onClick={()=> history.push("/add-sub-admin", { adminList })}
            >
              Add Sub Admin
            </Button>
          </div>
          <div className="table-responsive">
            <table className="table table-centered table-nowrap mb-0">
              <thead className="table-light">
                <tr>
                  <th>S No.</th>
                  <th>Name</th>
                  <th>Email</th>
                  <th>Code</th>
                  <th>Department</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                {loader
                ? <tr><td colSpan={5} className="text-center"><Spinner animation="border" /></td></tr>
                : (adminList && adminList.length > 0)
                ? adminList?.map((item, key) => (
                    <tr key={key}>
                      <td className="text-body fw-bold">{(key + 1)}</td>
                      <td className="text-body">{item?.full_name}</td>
                      <td className="text-body">{item?.email}</td>
                      <td className="text-body">{item?.employee_name || "-"}</td>
                      <td className="text-body">{item?.role && helperFunction.capitalizeAndReplaceSpace(item.role,"_")}</td>
                      <td>
                        <MdEdit
                          className="pointer"
                          onClick={()=> 
                          history.push(
                            "/edit-sub-admin?id=" + item._id,
                            item,
                          )
                          }
                          style={{ fontSize: "22px", color: "rgb(3, 35, 254)" }}
                        />

                        <MdOutlineDeleteForever
                          className="pointer"
                          onClick={() => setDeleteModal({modal:true,id:item._id})}
                          style={{ fontSize: "22px", color: "red" }}
                        />
                      </td>
                    </tr>
                  ))
                : <tr><td colSpan={5} className="text-center">Data Not Available</td></tr>
                }
              </tbody>
            </table>
          </div>

          {/* {/ Delete Modal /} */}
          <Modal
            show={deleteModal.modal}
            onHide={() => setDeleteModal({modal:false,id:null})}
            animation={false}
            centered
          >
            <Modal.Header closeButton>
              <Modal.Title>Delete Sub Admin</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <h6>Are you sure want to delete sub admin</h6>
            </Modal.Body>
            <Modal.Footer>
              <Button variant="success" onClick={() => setDeleteModal({modal:false,id:null})}>
                Close
              </Button>
              <Button variant="danger" onClick={handleDelete}>
                {(loader && <Spinner animation="grow" size="sm" />) || "Delete"}
              </Button>
            </Modal.Footer>
          </Modal>
        </div>
      </div>
    </div>
  );
};
